/* eslint-disable eqeqeq */
import {
  CmpSelectBox,
  CmpDatePicker,
  CmpTextFieldEnter,
  CmpButton,
  CmpStatusIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import {
  EasyLoadingData_Set,
  EasyLoadingHead_Set,
  EasyLoading_Head_Init,
} from "./SliceEasyLoading";
import moment from "moment";
import { fAlertToast } from "../../Utility/Utilitys";
import EasyLoading_Breadcrumbs from "./EasyLoading_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./EasyLoading.css";
import EasyLoadingModal from "./component/EasyLoadingModal";
import { statusData } from "./EasyLoadingAction";
import { vRdxUserInfo } from "../../Redux/roStore";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../Component/Common/ReuseableComponent/DetailCardComp";

export default function EasyLoadingHead() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const LocationEasyLoadingFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxSliceData = useSelector(
    (state) => state.SliceEasyLoading.value.EasyLoadingData
  );

  const [sLoadObj, setLoadObj] = useState(vRdxSliceData);
  const [sGridrows, setGridrows] = useState([]);
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const fOnChangeSelect = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnChangeInput = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
      if (sLoadObj.Scan != "") {
        // let summaryResp = await GetSummaryList(sLoadObj.statusVal);
        // if (summaryResp.length > 0) {
        //   let resultObj = summaryResp[0];
        //   dispatch(
        //     EasyLoadingHead_Set({
        //       VocTyp: resultObj.A_VocTyp,
        //       // VocTypName: resultObj.DocName,
        //       VocNo: resultObj.A_VocNo,
        //       PostDate: resultObj.A_PostDt,
        //       Party: resultObj.A_Party,
        //       PartyName: resultObj.partyname,
        //       dropid:resultObj.dropid,
        //       CBM:resultObj.CBM,
        //       Status: resultObj.Status,
        //     })
        //   );
        //   navigate("/EasyLoadingDetail");
        // } else {
        //   fAlertToast("FAILED", "Wrong Barcode");
        // }
      }
    }
  };
  const fLoad = async (e) => {
    dispatch(EasyLoadingData_Set(sLoadObj));
    await GetSummaryList(sLoadObj.statusVal, sLoadObj.loc);
    LocationEasyLoadingFocusOnLoad.current?.focus();
  };

  const fOnRowClick = (e) => {
    dispatch(
      EasyLoadingHead_Set({
        VocTyp: e.row.A_VocTyp,
        // VocTypName: e.row.DocName,
        VocNo: e.row.A_VocNo,
        // VocNo: e.row.RefNo,
        // PostDate: moment(e.row.A_PostDt, "DD/MM/YYYY")._d,
        PostDate: e.row.A_PostDt,
        Party: e.row.A_Party,
        PartyName: e.row.partyname,
        dropid: e.row.dropid,
        CBM: e.row.CBM,
        RefNo: e.row.RefNo,
        Status:
          e.row.Status == "Pending"
            ? "N"
            : e.row.Status == "Loaded"
              ? "Y"
              : e.row.Status == "Partial"
                ? "P"
                : "A",
      })
    );
    navigate("/EasyLoadingDetail");
  };
  //1st load
  const onLoadCall = async (e) => {
    dispatch(EasyLoading_Head_Init());
    if (vRdxSliceData.statusVal == "") {
      dispatch(
        EasyLoadingData_Set({
          dateFrom: new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate() - 10
          ),
          // dateFrom: tenDaysAgo,
          dateTo: new Date(),
          statusVal: statusData[0]?.id,
          Scan: "",
          loc: vRdxuserLoc[0]?.UID,
        })
      );
      setLoadObj((obj) => ({
        ...obj,
        dateFrom: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 10
        ),
        // dateFrom: tenDaysAgo,
        dateTo: new Date(),
        statusVal: statusData[0]?.id,
        Scan: "",
        loc: vRdxuserLoc[0]?.UID,
      }));
    }
    let summaryResp = await GetSummaryList(
      vRdxSliceData.statusVal == ""
        ? statusData[0]?.id
        : vRdxSliceData.statusVal,
      vRdxSliceData.loc == "" ? vRdxuserLoc[0]?.UID : vRdxSliceData.loc
    );
    setGridrows(summaryResp);
  };
  //API EasyLoading_SUMMARY_GETROW
  const GetSummaryList = async (xStatus, xLoc) => {
    const vRdxUserInfoObj = vRdxUserInfo();
    let vSummaryListObj = {
      date1: moment(sLoadObj.dateFrom).format("MM/DD/YYYY"),
      date2: moment(sLoadObj.dateTo).format("MM/DD/YYYY"),
      status: xStatus,
      scan: sLoadObj.Scan,
      usercd: vRdxUserInfoObj.UserID,
      Loc: xLoc,
    };
    const vSummaryList = await fExecuteAPI(
      "EASY_LOADING_SUMMARY_GETROW",
      vSummaryListObj
    );
    if (vSummaryList.Type == "SUCCESS") {
      let GridID = vSummaryList.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridrows(GridID);
      setShowModal(false);
      return GridID;
    } else {
      fAlertToast(
        "FAILED",
        vSummaryList.response.data.message ||
        vSummaryList.Message ||
        "Error in loading summarylist"
      );
      let GridID = [];
      setGridrows(GridID);

      return GridID;
    }
  };

  useEffect(() => {
    onLoadCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    LocationEasyLoadingFocusOnLoad.current?.focus();
  }, []);

  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end
  return (
    <div className="container-fluid">
      <div className="Breadcrumbs d-flex">
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <EasyLoading_Breadcrumbs />
      </div>

      <div className="Summary-container">
        <div className="d-flex justify-content-between mb-2">
          <CmpTextFieldEnter
            xref={LocationEasyLoadingFocusOnLoad}
            xLabelText={"Scan"}
            xVariant={"outlined"}
            xValue={sLoadObj.scan}
            xOnChange={(event) => fOnChangeInput(event)}
            xReadOnly={false}
            xType={"text"}
            xName={"Scan"}
            xOnKeyUp={(e) => {
              fOnKeyUp(e);
            }}
            xOnEnter={(e) => {
              fOnKeyUp(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          />
          <CmpButton
            xbtnName="Filter"
            xOnClick={() => {
              setShowModal(true);
            }}
            xVariant="contained"
            xSize="small"
          />
        </div>
        <Box
          sx={{
            height: vMediaQuery ? "65vh" : "75vh",
            overflowY: "auto",
            py: vMediaQuery ? "0px" : "8px",
            px: vMediaQuery ? "0px" : "10px",
          }}
        >
          <Grid container spacing={1}>
            {Array.isArray(sGridrows) &&
              sGridrows?.length > 0 &&
              sGridrows?.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <DetailCardComp
                    data={item}
                    onClick={(item) => {
                      fOnRowClick({ row: item });
                    }}
                    headerLabel={item.partyname}
                    content={
                      <Grid container spacing={1}>
                        <DetailInputDisplay
                          label="Invoice"
                          value={item.A_VocNo}
                        />
                        <DetailInputDisplay
                          label="Date"
                          value={moment(item.A_PostDt).format("DD/MM/YYYY")}
                        />
                        <DetailInputDisplay
                          label="Ref.No"
                          value={item.A_RefNo == null ? "" : item.A_RefNo}
                        />
                        <DetailInputDisplay
                          label="CBM"
                          value={item.CBM}
                        />
                        <DetailInputDisplay
                          label="Status"
                          value={<CmpStatusIcon xStatus={item?.Status} />}
                        />
                      </Grid>
                    }
                  />
                </Grid>
              ))}
          </Grid>
        </Box>
      </div>
      <EasyLoadingModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter Modal"
        component={
          <>
            <div className="p-4">
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <CmpDatePicker
                    xLabelText={"From"}
                    xValue={sLoadObj.dateFrom}
                    xOnChange={(newValue) => {
                      setLoadObj((obj) => ({ ...obj, dateFrom: newValue.$d }));
                    }}
                    xName={"dateFrom"}
                    xError={false}
                    xErrorMessage={false}
                    xFullWidth={true}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <CmpDatePicker
                    xLabelText={"To"}
                    xValue={sLoadObj.dateTo}
                    xOnChange={(newValue) =>
                      setLoadObj((obj) => ({ ...obj, dateTo: newValue.$d }))
                    }
                    xName={"dateTo"}
                    xError={false}
                    xErrorMessage={false}
                    xFullWidth={true}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <CmpSelectBox
                    xLabelText="Location"
                    xValue={
                      sLoadObj.loc === "" ? vRdxuserLoc[0]?.UID : sLoadObj.loc
                    }
                    xOnChange={(event) => fOnChangeSelect(event)}
                    xName={"loc"}
                    xData={vRdxuserLoc}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={false}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <CmpSelectBox
                    xLabelText="Status"
                    xValue={
                      sLoadObj.statusVal == ""
                        ? statusData[0].id
                        : sLoadObj.statusVal
                    }
                    xOnChange={(event) => fOnChangeSelect(event)}
                    xName={"statusVal"}
                    xData={statusData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={false}
                  />
                </Grid>
                {/* <Grid item md={4} xs={12}>
                <CmpTextFieldEnter
                  xref={LocationEasyLoadingFocusOnLoad}
                  xLabelText={"Scan"}
                  xVariant={"outlined"}
                  xValue={sLoadObj.scan}
                  xOnChange={(event) => fOnChangeInput(event)}
                  xReadOnly={false}
                  xType={"text"}
                  xName={"Scan"}
                  xOnKeyUp={(e) => {
                    fOnKeyUp(e);
                  }}
                  xOnEnter={(e) => {
                    fOnKeyUp(sEnterKeyObj);
                  }}
                  xSmShow={!!vMediaQuery}
                />
              </Grid> */}
                  <Grid
                    item
                    md={12}
                    xs={12}
                    className="bintransfet-data-load-btn text-center"
                  >
                    <CmpButton
                      xbtnName="Load"
                      xOnClick={fLoad}
                      xVariant="contained"
                      xSize="small"
                    />
                  </Grid>
                </Grid>
              </div>
            </>
          }
        />
      </div>
  );
}
